export default "__VITE_PUBLIC_ASSET__2e81e664__"